import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combina clases de Tailwind CSS de forma inteligente.
 *
 * Utiliza clsx para manejo condicional de clases y tailwind-merge
 * para resolver conflictos entre clases de Tailwind.
 *
 * @example
 * // Clases simples
 * cn('px-4 py-2', 'bg-blue-500')
 * // → 'px-4 py-2 bg-blue-500'
 *
 * @example
 * // Resolver conflictos (la última gana)
 * cn('px-4', 'px-6')
 * // → 'px-6'
 *
 * @example
 * // Condicionales
 * cn('text-base', isActive && 'text-blue-500', isDisabled && 'opacity-50')
 * // → 'text-base text-blue-500' (si isActive=true, isDisabled=false)
 *
 * @example
 * // Con objetos
 * cn('btn', {
 *   'btn-primary': isPrimary,
 *   'btn-disabled': isDisabled
 * })
 *
 * @example
 * // Con arrays
 * cn(['flex', 'items-center'], 'gap-2')
 * // → 'flex items-center gap-2'
 *
 * @param {...(string|Object|Array|boolean|null|undefined)} inputs - Clases a combinar
 * @returns {string} String con clases combinadas y optimizadas
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
